import { TOGGLE_SSO_DOMAIN_MODAL } from 'constants/actions';

const DEFAULT_MODAL_STATE = {
  showSsoDomainModal: false,
};

const ssoDomainModalReducer = (state = DEFAULT_MODAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_SSO_DOMAIN_MODAL:
      return {
        ...state,
        showSsoDomainModal: action.showModal,
      };
    default:
      return {
        ...state,
      };
  }
};

export default ssoDomainModalReducer;
